<template>
    <ProductInformation
        ref="productInformation"
        :product="context.product"
        :request="context.request"
        :customer-product="context.request.customerProduct"
        :included-substances="context.includedSubstances || []"
        :show-material-mixture-category-selector="settings.showMaterialMixtureCategorySelector"
        @validityChanged="handleValidityChange"
        @change="handleChange"
    />
</template>

<script>
import { ProductInformation } from '@/views/request/received/flow/components/simple'
import { createGeneralProductInformationValidation } from './general-product-information-validator'

export default {
    name: 'GeneralProductInformationStep',
    components: {
        ProductInformation,
    },
    props: {
        context: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        runtimeState: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.productInformation.emitValidity()
        })
    },
    methods: {
        handleValidityChange(isValid) {
            this.$emit('validity-change', createGeneralProductInformationValidation(isValid))
        },
        handleChange() {
            this.$emit('save-requested')
        },
    },
}
</script>
